import { html, TemplateResult } from "lit-html";
import { repeat } from 'lit-html/directives/repeat';
import { ifDefined } from "lit-html/directives/if-defined";

const classInfo = (index: number, activeProviderIndex: number) => index === activeProviderIndex ? "active" : undefined;

export const ProvidersListTemplate = (configs: IEmailTypeaheadComponent, props: IEmailTypeaheadProps): TemplateResult => {

  const {
    providersList,
    activeProviderIndex,
    handleClick,
    handleMouseEnter
  } = configs;

  const { providersLimit } = props;

  return html`
    <ul role="listbox" aria-hidden="false" class="dropdown-menu ts-dropdown-menu" @click=${handleClick}>
      ${repeat(providersList.slice(0, providersLimit), (provider: IAutocompleteEmailProvider) =>
    provider.value, (provider: IAutocompleteEmailProvider, index) => html`
        <li 
        tabindex="-1" 
        role="option"
        class=${ifDefined(classInfo(index, activeProviderIndex))}
        @mouseenter=${() => handleMouseEnter(index)}
        >
          <a tabindex="-1">${provider.label}</a>
        </li>
      `)}
    </ul>
    `;
}